export enum ConditionKindEnum {
  Equal,
  MoreThan,
  LessThan,
  Between,
  Sabet
}
